import {PaymentConfig} from '../types';

/**
 * Common configuration validation logic
 */
export class ConfigValidator {
    /**
     * Validate payment configuration
     */
    static validate(config: PaymentConfig): void {
        if (config.email == 'None') {
            config.email = '';
        }
        if (!['production', 'staging', 'development'].includes(config.environment)) {
            throw new Error('Environment must be "production", "staging", or "development"');
        }
        const hasProducts = config.products && config.products.length > 0;
        if (!config.product_id && !hasProducts) {
            throw new Error('Product ID is required');
        }
        if (config.product_id === 'dynamic') {
            if (config.amount === undefined || config.amount === null || config.amount <= 0) {
                throw new Error('Amount is required and must be greater than 0 for dynamic products');
            }
            if (!config.currency || typeof config.currency !== 'string' || config.currency.trim() === '') {
                throw new Error('Currency is required for dynamic products');
            }
            config.payment_type = 'onetime';
        }
        if (!config.payment_type) {
            throw new Error('Payment type is required');
        }
        if (!config.email && !config.user_id && !config.access_token) {
            throw new Error('SDK needs at least one of email, user_id, or access_token');
        }
        config.email = (config.email || '').toString().trim();
        if (config.email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(config.email)) {
                throw new Error('Invalid email format');
            }
        }

        // Validate new fields
        if (config.source_url && typeof config.source_url !== 'string') {
            throw new Error('source_url must be a string');
        }
        if (config.site_code && typeof config.site_code !== 'string') {
            throw new Error('site_code must be a string');
        }
        if (config.promotion_code && typeof config.promotion_code !== 'string') {
            throw new Error('promotion_code must be a string');
        }
        if (config.promotion_token && typeof config.promotion_token !== 'string') {
            throw new Error('promotion_token must be a string');
        }
        if (config.upgrade !== undefined && typeof config.upgrade !== 'boolean') {
            throw new Error('upgrade must be a boolean');
        }
    }
}
